<template lang="pug">
div
  .text-center.text-gray.p-2.text-italic(v-if="comentarios.length === 0") Nenhum comentário
  row(
    v-for="(comentario, index) in comentarios",
    :comentario="comentario",
    :key="index"
  )
</template>

<script>
import Row from "./Row";

export default {
  props: { comentarios: { type: Array, required: true } },
  components: { Row },
};
</script>
